import { Button, Drawer, NonIdealState, Tooltip } from '@blueprintjs/core';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import processService from '../../services/process.service.js';
import { AppContext } from '../../utils/context/app.context';
import { toast } from 'react-toastify';
import { AuthContext } from '../../utils/context/auth.context.ts';

export default function AuditComponent(props) {
    const { id, e, text, icon } = props;
    const [isOpen, setOpen] = useState(false)
    const [item, setItem] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const { t } = useTranslation();
    const appContext = useContext(AppContext)
    const authContext = useContext(AuthContext)

    function view(id, e) {
        if (authContext.verify({ pathname: "/prs" }, "GET")) {
            setLoading(true)
            processService.get_audit(id, e)
                .then(res => {
                    let history = res.data.map(d => {
                        let json = d.info.split(" : ")[1];
                        return {
                            user: d.user,
                            fecha: d.fecha,
                            history: JSON.parse(json)
                        }
                    })
                    setItem(history);
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    setLoading(false)
                })
        } else {
            toast.warning(t('auth.nopermit'))
        }
    }

    const body = (i) => (<div className='m-5'>
        <div className='row'>
            {i.map((item, n) => {
                let component = []
                for (const key in item.history) {
                    if (Object.prototype.hasOwnProperty.call(item.history, key)) {
                        const element = item.history[key];
                        component.push(<>
                            <div className='row border py-1'>
                                <div className='col'><strong>{key} :</strong></div>
                                <div className='col'>{element}</div>
                            </div>
                        </>)
                    }
                }
                return <>
                    <div className='row border py-1 app-table bg-dark text-light'>
                        <div className='col'><strong>{n === 0 ? t('audit.create') : t('audit.update') } : {item.fecha}</strong></div>
                        <div className='col'>{t("audit.user")}: {item.user}</div>
                    </div>
                    {component}
                    <hr />
                </>
            })}
        </div>

    </div>)

    const LOADING = <div class="text-center mt-5 pt-5">
        <div class="spinner-border" role="status">
        </div>
    </div>

    const NO_DATA = <div className='p-5'>
        <NonIdealState
            icon={'help'}
            iconSize={44}
            title={t('table.nodata')}
            description={t('table.nodatast')}
            layout={'vertical'}
        />
    </div>

    return (<>
        {authContext.verify({ pathname: "/prs" }, "GET") ? <>
            <Tooltip content={t('audit.see_more')} placement="top">
                {text ? <div onClick={() => {
                    setOpen(true);
                    view(id, e)
                }}><span className={`bp5-icon bp5-icon-${icon || "eye-open"} text-primary`} />{` ${text}`}</div> :
                    <Button icon={icon || "eye-open"} intent='primary' onClick={() => {
                        setOpen(true);
                        view(id, e)
                    }} />
                }
            </Tooltip>
            <Drawer
                className={'rockai-drawer'}
                icon="info-sign"
                onClose={() => setOpen(false)}
                isOpen={isOpen}
                title={t("audit.see_more")}
                size={"default"}

            >
                <div className='app-drawer'>
                    {isLoading ? LOADING : item ? body(item) : NO_DATA}
                </div>
            </Drawer>
        </> : null}

    </>
    );
}
